/* Tokens da marca (os mesmos do site). Fase 3 traz o pacote @licita/ui com tudo isto. */
:root {
  --bg: #f7f7fa;
  --bg2: #ffffff;
  --bg3: #eeeff6;
  --fg: #101219;
  --fg2: #3e4356;
  --mute: #5e6478;
  --line: #dadce6;
  --accent: #4a55d8;
  --accent-ink: #ffffff;
  --ok: #1f8a4c;
  --warn: #9a6b00;
  --bad: #c2413f;
  color-scheme: light;
}
[data-theme='dark'] {
  --bg: #0a0b10;
  --bg2: #10121a;
  --bg3: #161926;
  --fg: #ecedf2;
  --fg2: #b4b9cb;
  --mute: #8a90a5;
  --line: #1f2230;
  --accent: #7b86ff;
  --accent-ink: #0a0b10;
  --ok: #6ccb8a;
  --warn: #e3b341;
  --bad: #f08a8a;
  color-scheme: dark;
}
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  min-height: 100%;
}
body {
  background: var(--bg);
  color: var(--fg);
  font:
    15px/1.5 'Inter Tight',
    Inter,
    system-ui,
    sans-serif;
}
.mono {
  font-family: 'JetBrains Mono', ui-monospace, Menlo, monospace;
}
main {
  max-width: 560px;
  margin: 0 auto;
  padding: 96px 20px;
  display: grid;
  gap: 16px;
}
.logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 18px;
}
.logo .dev {
  color: var(--accent);
}
.cursor {
  display: inline-block;
  width: 8px;
  height: 18px;
  background: var(--accent);
  margin-left: 2px;
  animation: blink 1s steps(2) infinite;
  vertical-align: -3px;
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .cursor {
    animation: none;
  }
}
h1 {
  font-size: 28px;
  letter-spacing: -0.02em;
  margin: 0;
}
p {
  margin: 0;
  color: var(--fg2);
}
.chip {
  display: inline-block;
  border: 1px solid var(--line);
  background: var(--bg2);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12px;
  color: var(--mute);
}
a {
  color: var(--accent);
}
button {
  font: inherit;
  color: var(--fg);
  background: var(--bg2);
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
}
.small {
  font-size: 12px;
  color: var(--mute);
}
